export class Preferences {
    'key';
    'value';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "key",
            "baseName": "key",
            "type": "string",
            "format": ""
        },
        {
            "name": "value",
            "baseName": "value",
            "type": "{ [key: string]: any; }",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return Preferences.attributeTypeMap;
    }
    constructor() {
    }
}
